import {Injectable, OnDestroy} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {Subject} from "rxjs";
import {environment} from "../../environments/environment";

@Injectable()
export class VersionProvider implements OnDestroy {
	get currentVersion(): string {
		if (!environment.production) {
			return "4.2.0"
		}

		return this._currentVersion;
	}

	get currentHash(): string {
		return this._currentHash;
	}

	// this will be replaced by actual hash post-build.js
	private _currentHash = "{{POST_BUILD_ENTERS_HASH_HERE}}";
	private _currentVersion = "{{POST_BUILD_ENTERS_VERSION_HERE}}";

	private versionCheckInterval: any;

	public newVersionAvailableSubject: Subject<string> = new Subject<string>();

	constructor(private http: HttpClient) { }

	ngOnDestroy(): void {
		if (this.versionCheckInterval) {
			clearInterval(this.versionCheckInterval);

			this.versionCheckInterval = null;
		}
	}

	public initVersionCheck(frequency = 1000 * 60 * 30) {
		this.versionCheckInterval = setInterval(() => {
			this.checkVersion(environment.clockAppUrl);
		}, frequency);

		this.checkVersion(environment.clockAppUrl);
	}

	private checkVersion(url) {
		if (!environment.production) {
			return;
		}

		const versionUrl = url + "/build/version.json?t=" + new Date().getTime();

		this.http.get(versionUrl).subscribe((response: any) => {
					const hash = response.hash;

					const hashChanged = this.hasHashChanged(this._currentHash, hash);

					if (hashChanged) {
						this.newVersionAvailableSubject.next(hash);
					}

					this._currentHash = hash;
					this._currentVersion = response.version;
				},
				(err) => {}
			);
	}

	private hasHashChanged(currentHash, newHash) {
		if (!currentHash || currentHash === newHash) {
			return false;
		}

		return currentHash !== newHash;
	}
}



// WEBPACK FOOTER //
// ./src/providers/version/version.ts